import { CustomerType } from "../customer/customer";
import { SolarProduct } from "../solar-product/solar-product";
import { RoofType } from "../solar-recommendation-form/roofType";
import { Transaction } from "../transaction";

export type OrderType = {
	id: string;
	createdAt: string;
	customer: CustomerType;
	productDetails: SolarProduct;
	status: OrderStatus;
	description?: string;
	costOverview: OrderCostOverviewType;
	deliveryInformation: OrderDeliveryInformationType;
	monthlyPaymentDetails?: OrderMonthlyPaymentDetailsType;
};

export type OrderCostOverviewType = {
    productPrice: number;
    installmentPrice: number;
    insurancePrice: number;
    tax: number;
    shipping: number;
    totalAmount: number;
};

export type OrderDeliveryInformationType = {
    installationAddress: string;
    roofType?: RoofType;
    numberOfFloors?: number;
};

export type OrderMonthlyPaymentDetailsType = {
    depositPaidAt?: Date;
    durationOfPaymentsInMonths: number;
    deposit: number;
    monthlyPayment: number;
    interest: number;
    interestRate: number;
};

export interface SolarProviderOrderModel {
	id: string;
	customerName: string;
	name: string;
	paymentDate: string;
	status: string;
	statusChanged: string;
}
export type OrderWithReducedDetails = {
	id: string;
	customerName: string;
	name: string;
	paymentDate?: Date;
	status: OrderStatus;
	statusChanged?: Date;
};

export type OrderStatus =
	| "Pending"
	| "Approved"
	| "Declined"
	| "In Progress"
	| "Procesed"
	| "Delivery In Progress"
	| "Delivered"
	| "Installed"
	| "Retrieved"
	| "Under Maintenance"
	| "Completed"
	| "Declined By Customer";

export function allowedTransitionOrderStates(status: OrderStatus) {
	switch (status) {
		case "Pending":
			return ["Approved", "Declined"];
		case "Approved":
			return ["Declined"];
		case "Declined":
			return ["Approved"];
		case "Declined By Customer":
			return ["Declined By Customer"];
		case "In Progress":
			return ["Procesed"];
		case "Procesed":
			return ["Delivery In Progress"];
		case "Delivery In Progress":
			return ["Delivered"];
		case "Delivered":
			return ["Installed"];
		case "Installed":
			return ["Retrieved"];
		case "Retrieved":
			return ["Under Maintenance"];
		case "Under Maintenance":
			return ["Installed"];
		case "Completed":
			return [];
	}
}

export interface OrderInstallments {
	paymentDate: string;
	amount: number;
}

export interface OrderOfferModel {
	totalPayment: number;
	deposit: number;
	payments: OrderInstallments[];
}

export interface LoanDetails {
	customerName?: string;
	initialDeposit: number;
	loanPrincipal: number;
	loanInterest: number;
	loanInterestRate: number;
	amountPaidBack: number;
	outstandingAmount: number;
	durationInMonths: number;
}
export interface MandateStatus {
	monoDirectDebitConnected: boolean;
	paystackConnected: boolean;
}

export interface NextOrderPayment {
	isDeposit: true;
	amount: number;
	remainingAmount: number;
	dueDate: string;
	totalAmount: number;
	installments: [
		{
			amount: number;
			dueDate: string;
		}
	];
	paystackCardInformation: {
		last4: string;
		brand: string;
		expiryMonth: string;
		expiryYear: string;
	};
}

export interface OrderQuery {
	Page?: number;
	PageSize?: number;
	customerId?: string;
	orderId?: string;
}

export interface FulfilledLoans {
	orderId: string;
	deposit: number;
	capital: number;
	interest: number;
	durationInMonths: number;
	status: string;
}

export type CostOverviewDetails = {
	solarProduct: SolarProduct;
	orderInformation: OrderInformation;
	transaction?: Transaction;
}

export type OrderInformation = {
	roofType?: RoofType;
	numberOfFloors?: number;
	productPrice: number;
	installmentPrice?: number;
	deposit: number;
	monthlyInstallment: number;
	subTotal: number;
	tax: number;
	shipping: number;
	total: number;
	paymentMethod: string;
	durationOfPaymentsInMonths: number;
}

